import { getTokenPayload } from "@/utils/auth";

export const STAFF_ACCOUNT_TYPE = Object.freeze({ SUPER_ADMIN: 1, ADMIN: 2, TRAINER: 4 });
export const STAFF_RANK = Object.freeze({ SUPER_ADMIN: 100, ADMIN: 80, TRAINER: 40 });
export const STAFF_PERMISSION = Object.freeze({
  PORTAL_ACCESS: "STAFF_PORTAL_ACCESS",
  ENROLMENT_VIEW: "ENROLMENT_VIEW",
  ENROLMENT_MANAGE: "ENROLMENT_MANAGE",
  ATTENDANCE_VIEW: "ATTENDANCE_VIEW",
  ATTENDANCE_MANAGE: "ATTENDANCE_MANAGE",
  ASSESSMENT_VIEW: "ASSESSMENT_VIEW",
  ASSESSMENT_MANAGE: "ASSESSMENT_MANAGE",
  COMPETENCY_OUTCOME: "COMPETENCY_OUTCOME",
  COURSE_COMPLETE: "COURSE_COMPLETE",
  CERTIFICATE_ISSUE: "CERTIFICATE_ISSUE",
  TRAINER_MANAGE: "TRAINER_MANAGE",
});

const claim = (payload, name) => payload?.[name] ?? payload?.[`http://schemas.xmlsoap.org/ws/2005/05/identity/claims/${name}`];

export function getStaffIdentity() {
  const payload = getTokenPayload() || {};
  const rawPermissions = payload.staff_permission;
  return {
    userId: Number(payload.nameid || payload["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] || payload.sub || 0),
    accountTypeId: Number(payload.staff_account_type_id || 0),
    accountTypeName: payload.staff_account_type_name || "",
    rankNo: Number(payload.staff_rank_no || 0),
    permissions: Array.isArray(rawPermissions) ? rawPermissions : rawPermissions ? [rawPermissions] : [],
    isTestAccount: String(payload.staff_is_test_account).toLowerCase() === "true",
    name: claim(payload, "name") || payload.unique_name || "",
  };
}

export const hasPermission = (permissionCode) => getStaffIdentity().permissions.includes(permissionCode);
export const hasAnyPermission = (...permissionCodes) => permissionCodes.some(hasPermission);
export const isHigherRankThan = (targetRankNo) => getStaffIdentity().rankNo > Number(targetRankNo || 0);
export const isAccountType = (accountTypeId) => getStaffIdentity().accountTypeId === accountTypeId;
